'use client'

import { AuthProvider } from '@/providers/AuthProvider'
import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter'
import { PropsWithChildren } from 'react'

import { GlobalStyles, ThemeProvider } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import { theme } from '@/styles/theme'
import { ToastContainer } from 'react-toastify'
import { CompanyCacheProvider } from './CompanyCacheContext'
import { OverlayProvider } from './OverlayProvider'
import { ServiceCacheProvider } from './ServiceCacheContext'

export const VHMedicalProviders: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <AppRouterCacheProvider>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <div>
            <GlobalStyles
              styles={{
                body: { backgroundColor: '#E6EBFF' },
              }}
            />
          </div>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'hu'}>
            <ServiceCacheProvider>
              <CompanyCacheProvider>
                <OverlayProvider>{children}</OverlayProvider>
              </CompanyCacheProvider>
            </ServiceCacheProvider>
          </LocalizationProvider>
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover
            theme="colored"
          />
        </ThemeProvider>
      </AuthProvider>
    </AppRouterCacheProvider>
  )
}
